import Invoice from './Invoice.vue';

export default Invoice;
